export const timezones = [
  {
    label: 'Eastern',
    value: 'America/New_York',
  },
  {
    label: 'Central',
    value: 'America/Chicago',
  },
  {
    label: 'Mountain',
    value: 'America/Denver',
  },
  {
    label: 'Pacific',
    value: 'America/Los_Angeles',
  },
  {
    label: 'Alberta',
    value: 'America/Edmonton',
  },
];

export const printTimezones = [
  {
    label: 'ET',
    value: 'America/New_York',
  },
  {
    label: 'CT',
    value: 'America/Chicago',
  },
  {
    label: 'MT',
    value: 'America/Denver',
  },
  {
    label: 'PT',
    value: 'America/Los_Angeles',
  },
  {
    label: 'ABT',
    value: 'America/Edmonton',
  },
];
